import React, { useMemo } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Menu from "aldoo-ra/Menu"
import { shareOnFacebook } from "./share-providers/facebook"
import { shareOnX } from "./share-providers/x"
import { shareOnLinkedIn } from "./share-providers/linkedin"
import { shareOnReddit } from "./share-providers/reddit"
import { copyContent } from "./share-providers/copy"
import Localization from "aldoo-ra/Localization"

const BlogSharePanel = ({ url: propUrl, title }) => {
  const { lt } = Localization()
  // Use memoized value for URL with fallback, safe for SSR
  const url = useMemo(() => propUrl || (typeof window !== 'undefined' ? window.location.href : '#'), [propUrl])

  // Define the action map
  const actionMap = {
    "facebook.share": () => shareOnFacebook(url, title),
    "x.share": () => shareOnX(url, title),
    "linkedin.share": () => shareOnLinkedIn(url, title),
    "reddit.share": () => shareOnReddit(url, title),
    "content.copy": async () =>
      await copyContent(url, await lt("link_copied_to_clipboard")),
  }

  return (
    <div className="h-[26px] text-primary">
      <CMSRender
        contentType="MenuItem"
        match={{ "content.name": "BlogSharePanel" }}
        renderItem={(item, id) => {
          return (
            <Menu
              key={id}
              actionMap={actionMap}
              menuData={item}
              renderAs="hlist.icons"
              styleOverrides={{
                menu: "h-[26px] flex flex-row items-center gap-[54px] my-0",
                menu_item: "h-[26px] w-auto my-0",
              }}
            />
          )
        }}
      />
    </div>
  )
}

//deploy 17
export default BlogSharePanel